<template>
  <InstalarPantalla :open="open" :con-tutorial="false" titulo="Abrir turno" icono="mdi-cash-register"
    subtitulo="Cuenta el efectivo con el que empieza la caja.">
    <template #avisos>
      <div class="turno-contexto mb-4">
        <span v-if="cajaNombre"><v-icon small>mdi-point-of-sale</v-icon> {{ cajaNombre }}</span>
        <span v-if="usuario"><v-icon small>mdi-account-outline</v-icon> {{ usuario }}</span>
        <span><v-icon small>mdi-clock-outline</v-icon> {{ fechaHora }}</span>
      </div>
      <v-alert v-if="mensajeError" type="error" dense text class="mb-4">{{ mensajeError }}</v-alert>
    </template>

    <div :key="key">
      <ng-number-keyboard v-model="item.starting_amount" label="Dinero con el que abres la caja" rules="required"
        :filled="false" :dense="false" show-required="true"></ng-number-keyboard>
      <ng-textarea-keyboard v-model="item.observation" label="Nota (opcional)" :filled="false"
        :dense="false"></ng-textarea-keyboard>
    </div>

    <template #nota>
      <div class="instalar-aviso instalar-aviso--copia mt-2" v-if="!Number(item.starting_amount)">
        <span>Vas a abrir el turno sin dinero en caja ($0).</span>
      </div>
    </template>

    <template #acciones="{ invalid }">
      <v-btn block large color="success" elevation="0" :disabled="invalid || abriendo" :loading="abriendo"
        @click="openTurn()">
        {{ $t("open_turn") }} · {{ $filters.currency(Number(item.starting_amount) || 0, 0) }}
      </v-btn>
      <v-btn block text class="mt-2" :disabled="abriendo" @click="$emit('cancel')">Ahora no</v-btn>
    </template>
  </InstalarPantalla>
</template>
<script>
import InstalarPantalla from "@/components/base/InstalarPantalla.vue";
import { revisarEstadoDeCuenta } from "@/plugins/estadoDeCuenta";

export default {
  name: "OpenTurn",
  components: { InstalarPantalla },
  props: ["open"],
  data: () => ({
    dialog: true,
    key: 0,
    item: { starting_amount: 0, observation: null, active: true, opened: true },
    app_version: null,
    installation: null,
    cajaNombre: "",
    abriendo: false,
    mensajeError: "",
    fechaHora: "",
  }),
  computed: {
    usuario() {
      const u = this.$store.getters.user;
      return u ? u.name : "";
    },
  },
  mounted() {
    this.load();
    this.$store.commit('setDrawer', false)
    this.fechaHora = this.$filters.datetime(new Date());
    this.cargarCaja();
  },
  methods: {
    openHelp() {
      window.open(process.env.VUE_APP_BASECONFIG_URL_HELP, "_blank");
    },
    // El nombre de la caja de este equipo, para que quien abre el turno vea en cuál lo hace.
    async cargarCaja() {
      try {
        const instalacion = await this.$db.getInstallation();
        const caja = instalacion && (await this.$db.getCashRegister(instalacion.cash_id));
        this.cajaNombre = (caja && caja.name) || "";
      } catch (e) {
        this.cajaNombre = "";
      }
    },
    async openTurn() {
      if (this.abriendo) return;
      this.abriendo = true;
      this.mensajeError = "";
      try {
        this.installation = await this.$db.getInstallation();
        this.item['cash_register'] = { id: this.installation.cash_id };
        this.item['subsidiary'] = this.installation.subsidiary_id;
        this.item['opening_date'] = this.$filters.datetime((new Date()));
        this.item['created_at'] = this.$filters.datetime((new Date()));
        let opened = await this.$pos.syncTurn(this.item);
        if(opened){
          this.$emit('opened', this.item)
          this.$pos.createOrder();
          // Abrir turno es el otro momento en que el cajero puede hacer algo con el aviso.
          revisarEstadoDeCuenta(this.$http, this.$store);
        }
      } catch (e) {
        // Si el servidor contestó con un error ya se le mostró; aquí queda el aviso en la propia pantalla.
        this.mensajeError = (e && e.msg) || "No se pudo abrir el turno. Revisa la conexión e inténtalo de nuevo.";
      } finally {
        this.abriendo = false;
      }
    },
    load() {
      setTimeout(async () => {
        this.app_version = process.env.VUE_APP_BASECONFIG_APP_VERSION;

      }, 50);
    },
  },
};
</script>
<style>
.turno-contexto {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
  background: rgba(0, 0, 0, 0.04);
}
</style>
